module.exports = __webpack_public_path__ + "8cb0284f9e75c883c054b41b5d7e8fed.glb";